const translations = {
    default: {
        consentModal: {
            title: window.core.localization.cookieconsent.modal.title,
            description: window.core.localization.cookieconsent.modal.description,
            acceptAllBtn: window.core.localization.cookieconsent.modal.primary_btn,
            acceptNecessaryBtn: window.core.localization.cookieconsent.modal.secondary_btn,
            showPreferencesBtn: window.core.localization.cookieconsent.button.label,
        },
        preferencesModal: {
            title: window.core.localization.cookieconsent.settings.title,
            acceptAllBtn: window.core.localization.cookieconsent.settings.accept_all_btn,
            acceptNecessaryBtn: window.core.localization.cookieconsent.settings.reject_all_btn,
            savePreferencesBtn: window.core.localization.cookieconsent.settings.save_settings_btn,
            closeIconLabel: window.core.localization.cookieconsent.settings.close_btn_label,
            sections: [
                {
                    title: window.core.localization.cookieconsent.blocks.title,
                    description: window.core.localization.cookieconsent.blocks.description,
                },
                {
                    title: window.core.localization.cookieconsent.blocks.necessary.title,
                    description:
                        window.core.localization.cookieconsent.blocks.necessary.description,
                    linkedCategory: "necessary",
                },
                {
                    title: window.core.localization.cookieconsent.blocks.analytics.title,
                    description:
                        window.core.localization.cookieconsent.blocks.analytics.description,
                    linkedCategory: "analytics",
                },
                {
                    title: window.core.localization.cookieconsent.blocks.marketing.title,
                    description:
                        window.core.localization.cookieconsent.blocks.marketing.description,
                    linkedCategory: "marketing",
                },
            ],
        },
    },
};

export default translations;
